import { Fragment, useEffect, useState } from "react";

import { useNewSubscriberContext } from "../../Context/NewSubsciberContext";

const Otp = ({ sendOTP, submit, isOtpValid, credentials, skip, back }) => {
  const [timer, setTimer] = useState(60);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [otpError, setOtpError] = useState(false);
  const { mobileNumber, email } = useNewSubscriberContext();

  const handleChange = (index) => (e) => {
    const value = e.target.value;
    if (value.length <= 1) {
      setOtp([...otp.slice(0, index), value, ...otp.slice(index + 1)]);
      if (index !== 5 && !!value) {
        document.getElementById(`textInput${index + 1}`).focus();
      } else {
        // document.getElementById(`textInput${index}`).blur();
      }
    }
  };

  const handleKeyDown = (index) => (e) => {
    if (e.keyCode === 8) {
      setOtp([...otp.slice(0, index), "", ...otp.slice(index + 1)]);

      if (index !== 0) {
        if (e.target.value == "") {
          document.getElementById(`textInput${index - 1}`).focus();
        } else {
          document.getElementById(`textInput${index}`).focus();
        }
      }
    }
  };

  useEffect(() => {
    sendOTP();
    const interval = setInterval(() => {
      setTimer((prevState) => prevState - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (timer <= 0) {
      setOtpError(true);
    }
  }, [timer]);

  const resendOtp = () => {
    sendOTP();
    setTimer(60);
    setOtpError(false);
    setOtp(["", "", "", "", "", ""]);
  };

  const submitOtp = () => {
    const otpCode = otp.join("");
    const status = submit(otpCode);
    if (status) {
      setOtpError(true);
      setOtp(["", "", "", "", "", ""]);
    }
  };

  return (
    <Fragment>
      <>
        <div className="otp-paper1">
          <div
            className="otp-header"
            style={{
              textAlign: "left",
              color: "#002856",
              fontSize: "20px",
              fontFamily: `'Roboto', sans-serif`,
            }}
          >
            Enter OTP
          </div>
          <div style={{ fontSize: "16px", fontFamily: `'Roboto', sans-serif` }}>
            We are extracting the KYC details from CKYC account please enter the
            OTP which is send to your registered mobile number <br/>
            <b>{mobileNumber}</b>
            and email <b>{email}</b>
            {credentials}.
          </div>
          <div
            className="forgot-otp"
            style={{ display: "flex", justifyContent: "flex-start" }}
          >
            {Array(6)
              .fill(0)
              .map((item, index) => (
                <OtpInput
                  value={otp[index]}
                  key={index}
                  onChange={handleChange(index)}
                  onKeyDown={handleKeyDown(index)}
                  id={`textInput${index}`}
                />
              ))}
          </div>
          {timer > 0 ? (
            <div
              className="resend-otp"
              // style={{ textAlign: "left", fontSize: "15px" }}
            >
              Resend OTP in 00:{timer}
            </div>
          ) : (
            <div className="resend-otp" onClick={() => resendOtp()}>
              Resend OTP
            </div>
          )}
          {!isOtpValid && !!otpError && (
            <div className="d-flex justify-content-left mt-3">
              <span className="text-danger">
                Please Enter a valid One Time Password
              </span>
            </div>
          )}

          <div
            className="d-flex justify-content-space-between mt-4"
            style={{ gap: "50px" }}
          >
            <button
              className="otp-submit-button1"
              id="otp-submit-button"
              style={{ color: "#007ac8", cursor: "pointer" }}
              onClick={back}
            >
              Back
            </button>
            <button
              style={{
                width: `190px`,
                background: `#0072BC`,
                borderRadius: `4px`,
                border: `0.5px solid #007ac8`,
                color: `white`,
              }}
              onClick={submitOtp}
              // disabled={otp.join("").length !== 6}
              // onClick={() => skip()}
            >
              Submit
            </button>
          </div>

          <div
            className="d-flex justify-content-center mt-4"
            style={{
              textDecoration: "underline",
              fontSize: "16px",
              fontWeight: 500,
              color: "#007ac8",
              cursor: "pointer",
            }}
            onClick={() => skip()}
          >
            Skip OTP Verification
          </div>
        </div>
      </>
    </Fragment>
  );
};

const OtpInput = (props) => {
  return (
    <div>
      <input
        className="otp_input number-input text-center"
        type="number"
        {...props}
      />
    </div>
  );
};

export default Otp;
